import Network from "../networkHandler/Network";

/**
 * Detect whether a published game uses the new story format.
 *
 * New-format stories have a `story.json` file alongside `game.html` on the
 * platform static server; legacy games do not. This is the source of truth
 * the translation flow relies on — `story.json` is what the ai-service reads.
 *
 * Uses GET because the platform server's `story.json` route only handles GET
 * and returns 404 for HEAD. We abort the body as soon as headers arrive so
 * we don't download the full payload.
 *
 * Returns `true` on 2xx, `false` on 404 / network failure. A defensive false
 * is preferable here: an unreachable check should not trigger translation of
 * a story that might turn out to be legacy.
 */
export async function hasNewStoryFormat(gameId: number): Promise<boolean> {
	const platformUrl = Network.withServerUploadGame().getServerUrl();
	if (!platformUrl) return false;

	const controller = new AbortController();
	try {
		const res = await fetch(`${platformUrl}/game/${gameId}/story.json`, {
			method: "GET",
			signal: controller.signal,
		});
		// Headers are in — we don't need the body.
		controller.abort();
		return res.ok;
	} catch {
		return false;
	}
}
